module.exports = __webpack_public_path__ + "img/EmitirIcon.3a5bd2fa.svg";